import { Form, Input } from 'antd'

const StepTwo = () => {
  return (
    <Form.Item
      label="Insira sua senha"
      name="password"
      rules={[{ required: true }]}
    >
      <Input.Password placeholder="Senha" />
    </Form.Item>
  )
}

export default StepTwo
